<template>
  <div>
    <el-dialog
      title="How to use Markdown"
      top="10vh"
      :append-to-body="true"
      :visible.sync="isVisible">
      <div class="u-mb3">
        <h1>Styling messages</h1>
        <p>
          Use formatting to add clarity and detail to your messages when you need it.
          Your text can be formatted by using the symbols described below.
        </p>
      </div>
      <el-table
        border
        :data="markdownOptions">
        <el-table-column
          property="name"
        >
        <template slot-scope="{row}">
          <strong>
            {{row.name}}
          </strong>
        </template>
        </el-table-column>
        <el-table-column
          property="markdown"
          label="Markdown"
        />
        <el-table-column
          label="Result"
        >
        <template slot-scope="{row}">
          <note-editor
            :shouldShowMenuBar="false"
            :editable="false"
            :value="row.html" />
        </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-button
      type="text"
      @click="isVisible = true">
      <small><strong>Markdown</strong> is supported</small>
    </el-button>
  </div>
</template>

<script>
import NoteEditor from '#/notes/components/NoteEditor'

export default {
  name: 'NotesMarkdownHelpModal',
  data () {
    return {
      isVisible: false,
      markdownOptions: [
        {
          name: 'Bold',
          markdown: '**your text**',
          html: '<strong>your text</strong>'
        },
        {
          name: 'Italic',
          markdown: '*your text*',
          html: '<em>your text</em>'
        },
        {
          name: 'Underline',
          markdown: '_your text_',
          html: '<u>your text</u>'
        },
        {
          name: 'Strikethrough',
          markdown: '~your text~',
          html: '<s>your text</s>'
        },
        {
          name: 'Quote',
          markdown: '> your text',
          html: '<blockquote>your text</blockquote>'
        },
        {
          name: 'Bullet list',
          markdown: '* item',
          html: '<ul><li>item</li></ul>'
        },
        {
          name: 'Numbered list',
          markdown: '1. item',
          html: '<ol><li>item</li></ol>'
        }
      ]
    }
  },
  components: {
    NoteEditor
  }
}
</script>
